import { DeliveryApiDatasource } from '../data/datasources/delivery-api.datasource';
import { DeliveryRepositoryImpl } from '../data/repositories/delivery.repository.impl';

const api = new DeliveryApiDatasource();
const repository = new DeliveryRepositoryImpl(api);

export const deliveryContainer = { repository };
